module.exports = __webpack_public_path__ + "static/media/image_1.0524f2e9.png";